import { render } from "./TemplatePostit.vue?vue&type=template&id=e789023e&scoped=true"
import script from "./TemplatePostit.vue?vue&type=script&lang=js"
export * from "./TemplatePostit.vue?vue&type=script&lang=js"

import "./TemplatePostit.vue?vue&type=style&index=0&id=e789023e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e789023e"]])

export default __exports__